import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { API } from "../../Helper";

const WhatsappFloatingIcon = () => {

    const [setting, setSetting] = useState({});

    const fetchSettings = async () => {
        try {
            const response = await axios.get(`${API}/admin/websiteconfig`);
            const data = response.data;

            console.log(data.data.contactChannels.social);
            if (data?.data?.contactChannels?.social) {
                setSetting(data?.data?.contactChannels?.social);
            }
            // if (data?.data?.contactChannels?.support) {
            //   setSupportSettings(data?.data?.contactChannels?.support);
            // }
        } catch (error) {
            console.error("Error fetching settings:", error);
        }
    };


    useEffect(() => {
        fetchSettings();
    }, [])


    return (
        <a
            href={setting[5]?.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                position: "fixed",
                bottom: "80px",
                right: "20px",
                zIndex: 1000,
                backgroundColor: "#25D366",
                borderRadius: "50%",
                width: "55px",
                height: "55px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textDecoration: "none",
            }}
        >
            <img
                src="https://img.icons8.com/ios-filled/50/ffffff/whatsapp.png"
                alt="WhatsApp"
                style={{ width: "30px", height: "30px" }}
            />
        </a>
    );
};

export default WhatsappFloatingIcon;